<template>
  <div>
    <div class="setHeightFullGrey paddingbottom50">
      <div class="van-cell van-field" @click="showCities()">
        <div class="van-cell__title van-field__label"><span>城市站点</span></div>
        <div class="van-cell__value flexRow">
          <span style="color: #323233;">{{ city || '请选择分站' }}</span>
        </div>
      </div>
      <van-field :required="true" v-model="listData.name" clearable label="姓名" placeholder="请输入姓名" />
      <div class="van-cell van-field">
        <div class="van-cell__title van-field__label"><span>性别</span></div>
        <div class="van-cell__value flexRow">
          <div class="marginRightXm">
            <van-switch size="20px" v-model="switchSex" />
          </div>
          <div style="margin: 0 15rpx;line-height: 30px;height: 100%;">{{ switchSex ? '男' : '女' }}</div>
        </div>
      </div>

      <van-field :required="true" v-model="listData.idnumber" clearable label="身份证" placeholder="请输入身份证号码" />
      <van-field v-model="listData.passport" clearable label="护照" placeholder="请输入护照号码" />
      <div class="van-cell van-field" @click="showDate = true">
        <div class="van-cell__title van-field__label"><span>生日</span></div>
        <div class="van-cell__value flexRow">
          <span style="color: #323233;">{{ listData.birthday }}</span>
        </div>
      </div>
      <van-field :required="true" v-model="listData.city2" clearable label="常在地址" placeholder="请输入常在地址" />

      <div class="van-cell van-field" @click="showCityPop = true">
        <div class="van-cell__title van-field__label"><span>现居地址</span></div>
        <div class="van-cell__value flexRow">
          <span style="color: #323233;">{{ listData.city }}</span>
        </div>
      </div>
      <van-field :required="true" v-model="listData.college" clearable label="大学名称" placeholder="请输入大学名称" />
      <van-field :required="true" v-model="listData.grade" clearable label="所在年级" placeholder="请输入所在年级" />
      <van-field :required="true" v-model="listData.major" clearable label="所在专业" placeholder="请输入所在专业" />
      <van-field :required="true" v-model="listData.speciality" type="textarea" clearable rows="3" autosize label="个人特长"
        placeholder="请输入个人特长" />
      <van-field :required="true" v-model="listData.exp_social" type="textarea" clearable rows="3" autosize label="个人经历"
        placeholder="请输入个人经历" />
      <van-field v-model="listData.remark" type="textarea" clearable rows="4" autosize label="个人备注"
        placeholder="请输入个人备注" />
      <van-cell title="个人近照"></van-cell>
      <div class="paddingXm" style="background-color:#fff;">
        <van-uploader :before-read="beforeRead" v-model="imgList" :max-count="1" />
      </div>

      <van-field v-model="listData.camera" clearable label="相机型号" placeholder="请输入相机型号" />

      <van-cell title="拍摄作品(儿童照)"></van-cell>
      <div class="paddingXm" style="background-color:#fff;">
        <van-uploader :before-read="zuopin" v-model="zuopinList" :max-count="4" />
      </div>

      <van-button @click="save" type="info" size="large">保存</van-button>
    </div>

    <!-- <div class="fixBottom">
			
		</div> -->
    <!-- 添加生日弹窗 -->
    <van-popup v-model="showDate" position="bottom">
      <van-datetime-picker show-toolbar v-model="currentTime" type="date" :min-date="minDate" @confirm="confirmDate"
        @cancel="showDate = false" />
    </van-popup>
    <!-- 城市三级联动 -->
    <van-popup v-model="showCityPop" position="bottom">
      <van-area :area-list="areaList" @confirm="confirmCity" :columns-num="3" title="选择城市" />
    </van-popup>

    <Subsite ref="subsite" :siteDetail="city" @onSelected="selectCity"></Subsite>
  </div>
</template>

<script>
import addressList from '@/common/area.js'
import { mapState, mapMutations } from 'vuex'
export default {
  computed: {
    ...mapState(['site']),
  },
  created () {
    this.token = this.$route.query.token
    if (this.site) {
      this.city = this.site
    } else {
      this.$store.commit('ChangeSite', '杭州')
    }
  },
  mounted () {
    if (this.isWeixin()) {
      document.addEventListener('WeixinJSBridgeReady', function onBridgeReady () {
        // 通过下面这个API隐藏右上角按钮
        WeixinJSBridge.call('hideOptionMenu');
      });
    }

  },
  data () {
    return {
      city: null,
      imgList: [],
      showCityPop: false,
      minDate: new Date(1950, 1, 1),
      currentTime: new Date(1980, 0, 1),
      showDate: false,
      joyPageStatus: '',
      listData: {
        city: '北京市-北京市-东城区',
        birthday: '1980-1-1',
      },
      switchSex: false,
      areaList: addressList,
      idPhoto: '',
      zuopinList: [],
    }
  },
  methods: {
    beforeRead (files) {
      const _this = this
      let reader = new FileReader()
      reader.readAsDataURL(files) // 这里是最关键的一步，转换就在这里
      reader.onloadend = function () {
        lrz(this.result, { quality: 0.5 })
          .then(function (rst) {
            _this.idPhoto = rst.base64
          })
          .catch(function (err) {
            console.log(err)
          })
      }
      return true
    },
    async zuopin (file) {
      console.log(file, '上传的文件哈哈哈哈')
      // 压缩图片
      let imgFile = await this.blobToBase64(file)
      console.log(imgFile, '压缩后的图片文件获取')
      return imgFile
    },
    async blobToBase64 (blob) {
      const self = await this // 绑定this
      const reader = await new FileReader() // 实例化一个reader文件
      await reader.readAsDataURL(blob) // 添加二进制文件
      return new Promise(function (resolve, reject) {
        reader.onload = async function (event) {
          const base64 = await event.target.result // 获取到它的base64文件
          const scale = 0.6 // 设置缩放比例 （0-1）
          let file = await self.compressImg(base64, scale)
          resolve(file)
        }
      })
    },
    async compressImg (base64, scale) {
      console.log(`执行缩放程序，scale=${scale}`)
      // 处理缩放，转换格式
      // 用canvas来压缩
      const img = new Image()
      img.src = base64
      return new Promise(function (resolve, reject) {
        img.onload = async function () {
          const canvas = document.createElement('canvas')
          const ctx = canvas.getContext('2d')
          canvas.setAttribute('width', this.width)
          canvas.setAttribute('height', this.height)
          ctx.clearRect(0, 0, canvas.width, canvas.height)
          ctx.drawImage(img, 0, 0, canvas.width, canvas.height)
          // 转成base64 文件
          base64 = canvas.toDataURL('image/jpeg', 0.5)
          const arr = base64.split(',')
          const mime = arr[0].match(/:(.*?);/)[1]
          const bytes = atob(arr[1])
          const bytesLength = bytes.length
          const u8arr = new Uint8Array(bytesLength)
          for (let i = 0; i < bytes.length; i++) {
            u8arr[i] = bytes.charCodeAt(i)
          }
          const file = await new File([u8arr], 'filename', { type: mime })
          resolve(file)
        }
      })
    },
    selectCity (val) {
      this.city = val
      console.log('this.listData.site是', this.city)
      this.$store.commit('ChangeSite', val)
    },
    showCities () {
      this.$refs.subsite.show()
    },
    confirmCity (value) {
      let name = ''
      for (let i in value) {
        if (i < 2) {
          name += value[i].name + '-'
        } else {
          name += value[i].name
        }
      }
      this.showCityPop = false
      this.listData.city = name
    },
    save () {
      const that = this
      if (that.city == '' || that.city == null) {
        that.$dialog.alert({
          message: '请选择城市站点',
        })
      } else if (that.listData.city2 == '' || that.listData.city2 == null) {
        that.$dialog.alert({
          message: '常在地址不能为空',
        })
      } else if (that.listData.college == '' || that.listData.college == null) {
        that.$dialog.alert({
          message: '大学名称不能为空',
        })
      } else if (that.listData.grade == '' || that.listData.grade == null) {
        that.$dialog.alert({
          message: '所在年级不能为空',
        })
      } else if (
        that.listData.speciality == '' ||
        that.listData.speciality == null
      ) {
        that.$dialog.alert({
          message: '个人特长不能为空',
        })
      } else if (that.imgList.length == 0) {
        that.$dialog.alert({
          message: '请上传个人近照',
        })
      } else {
        that.$toast.loading({
          message: '注册中...',
          forbidClick: true,
          loadingType: 'spinner',
        })
        let sex = that.switchSex ? '男' : '女'

        let picList = []
        for (let i = 0; i < this.zuopinList.length; i++) {
          picList[i] = this.zuopinList[i].content
        }

        let query = {
          name: that.listData.name,
          idnumber: that.listData.idnumber,
          exp_social: that.listData.exp_social,
          site: that.city,
          passport: that.listData.passport,
          sex: sex,
          image: that.idPhoto,
          birthday: that.listData.birthday,
          city: that.listData.city,
          city2: that.listData.city2,
          college: that.listData.college,
          grade: that.listData.grade,
          major: that.listData.major,
          speciality: that.listData.speciality,
          remark: that.listData.remark,
          pic: picList,
          camera: that.listData.camera,
        }
        if (that.listData.idnumber) {
          that.$store.commit('SET_TOKEN', that.token)
          try {
            that.$axios.post('user/reg', query).then((res) => {
              that.$toast.clear()
              if (res.data.code == 200) {
                that.$store.commit('SET_TOKEN', res.data.data.token)
                that.$store.commit('ChangeSite', res.data.data.site)
                that.$dialog
                  .confirm({
                    title: '提示',
                    message: '注册成功',
                    showCancelButton: false,
                  })
                  .then(() => {
                    that.$router.replace({ path: '/' })
                  })
              } else {
                that.$toast.fail(res.data.msg)
              }
            })
          } catch (e) {
            if (that.$mConfig.debug) {
              console.log(e)
            }
          }
        } else {
          if (that.listData.passport) {
            try {
              that.$store.commit('SET_TOKEN', that.token)
              that.$axios.post('user/reg', query).then((res) => {

                if (res.data.code == 200) {
                  that.$toast.clear()
                  that.$store.commit('SET_TOKEN', res.data.data.token)
                  that.$store.commit('ChangeSite', res.data.data.site)
                  that.$dialog
                    .confirm({
                      title: '提示',
                      message: '注册成功',
                      showCancelButton: false,
                    })
                    .then(() => {
                      that.$router.replace({ path: '/' })
                    })
                } else {
                  that.$toast.fail(res.data.msg)
                }
              })
            } catch (e) {
              if (that.$mConfig.debug) {
                console.log(e)
              }
            }
          } else {
            that.$toast.fail('身份证或护照不能为空')
          }
        }
      }
    },
    // 生日弹窗
    confirmDate (value) {
      let d = new Date(value)
      this.listData.birthday =
        d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate()
      this.showDate = false
    },
  },
}
</script>

<style scoped="scoped"></style>
